<template>
    <div class="d-flex flex-column align-items-center">
        <div class="card align-items-center p-3">
            <div
                v-if="showHeading"
                id="heading"
                class="text-center fw-normal mt-0 h3 text-break">
                {{ heading }}
            </div>
            <div
                v-if="showBody"
                id="body"
                class="fw-normal mt-0 h5 text-break"
                style="white-space: pre-line">
                {{ body }}
            </div>
            <div
                v-if="showDefault"
                id="ProjectNumberCell"
                class="h2">
                {{ submittedProjectNumber }}
            </div>
        </div>
    </div>
</template>

<script>
    import { KEYS, NAMESPACE } from "./i18n/submitProject.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            submittedProjectNumber: { type: String, required: true },
            customMessage: {
                type: Object,
                default() {
                    return {
                        EnableMessage: false,
                        Heading: null,
                        Body: null
                    };
                }
            }
        },
        computed: {
            heading() {
                return this.message.EnableMessage ? this.message.Heading : this.thankYouMessage;
            },
            showHeading() {
                return !(this.message.EnableMessage && this.message.Heading == null);
            },
            body() {
                return this.message.EnableMessage ? this.message.Message : this.projectNumberHeader;
            },
            showBody() {
                return !(this.message.EnableMessage && this.message.Message == null);
            },
            showDefault() {
                return !this.message.EnableMessage;
            },
            message() {
                return (
                    this.customMessage || {
                        EnableMessage: false,
                        Heading: null,
                        Body: null
                    }
                );
            },
            ...mapI18n(KEYS, NAMESPACE)
        }
    };
</script>
